import { RiShieldCheckFill, Tooltip, TooltipArrow, TooltipContent, TooltipTrigger } from 'component-library';
import { useTranslation } from 'react-i18next';

import { VerifiedByEnum, VerifiedByType } from '@/api/rest/resources/types/IndicatorProduct';

type VerifiedIconProps = {
  verifiedBy?: string;
  className?: string;
};

export const VerifiedIcon = ({ verifiedBy, className }: VerifiedIconProps) => {
  const { t } = useTranslation();

  if (!verifiedBy) {
    return <RiShieldCheckFill className={className} />;
  }

  const isKnownVerifiedBy = Object.values(VerifiedByEnum).includes(verifiedBy as VerifiedByEnum);

  return (
    <Tooltip>
      <TooltipTrigger>
        <RiShieldCheckFill className={className} />
      </TooltipTrigger>
      <TooltipContent sideOffset={3} side='top'>
        {isKnownVerifiedBy
          ? t(`global.widget.indicatorLibraryCard.verified.by.${verifiedBy as VerifiedByType}`)
          : verifiedBy}
        <TooltipArrow />
      </TooltipContent>
    </Tooltip>
  );
};
